import { FieldSelectStore, FieldSelectStoreOptions } from '@/stores/local/shared/form/FieldSelectStore';
import { OptionEntityWithAdditionalFields } from '@/types/OptionEntity';
import type { BaseResponse } from '@/utils/api/types';

import { LIFESPAN_OPTIONS } from './config';

type LifespanSelectStoreOptions = Omit<FieldSelectStoreOptions<OptionEntityWithAdditionalFields>, 'getOptions'>;

export class LifespanSelectStore extends FieldSelectStore<OptionEntityWithAdditionalFields> {
  constructor(options?: LifespanSelectStoreOptions) {
    super({
      ...options,
      getOptions: async (): Promise<BaseResponse<{ items: OptionEntityWithAdditionalFields[]; total: number }>> => {
        return {
          isError: false,
          data: {
            items: LIFESPAN_OPTIONS,
            total: LIFESPAN_OPTIONS.length,
          },
        };
      },
    });
  }
}
